"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatusService = void 0;
const http_1 = require("@angular/common/http");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const shared_1 = require("../../mma/shared");
const constants = require("../util/constants");
class OrderStatusService extends shared_1.RestService {
    /**
     * @returns Observable of type OrderModel - will return order details
     */
    getOrderDetails(orderId, zipCode, cachedData) {
        if (this.orderData && cachedData) {
            return rxjs_1.of(this.orderData);
        }
        return this.get(constants.orderDetailsUrl + orderId + '?zipCode=' + zipCode).pipe(operators_1.map((data) => {
            this.orderData = data;
            return data;
        }));
    }
    getPreOrderDetails(orderId, subId) {
        let url = constants.preorderUrl + orderId;
        if (subId) {
            url = url + '&subId=' + subId;
        }
        return this.get(url).pipe(operators_1.map((data) => {
            this.preOrderData = data;
            return data;
        }));
    }
    validateSSN(content) {
        return this.post(constants.validateSSNUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getLoginStatus() {
        return this.get(constants.loginStatusUrl).pipe(operators_1.map((data) => data));
    }
    getCartCount() {
        return this.get(constants.cartCountUrl).pipe(operators_1.map((data) => data));
    }
    clearCart() {
        return this.post(constants.clearCartUrl).pipe(operators_1.map((data) => data));
    }
    editPreorderDetails(orderContent) {
        let inputArgs;
        if (orderContent) {
            const data = JSON.stringify(orderContent.preOrderInfo);
            inputArgs = new http_1.HttpParams().set('preOrderInfo', data);
        }
        return this.post(constants.editPreorderUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    cancelPreorder(orderContent, isCancelOnlyAccessory) {
        let inputArgs;
        if (orderContent) {
            if (orderContent.lineItemId) {
                inputArgs = new http_1.HttpParams().set('preOrderId', orderContent.preOrderId).set('lineItemId', orderContent.lineItemId)
                    .set('lineItemStatus', orderContent.lineItemStatus).set('isCancelOnlyAccessory', isCancelOnlyAccessory);
            }
            else {
                inputArgs = new http_1.HttpParams().set('preOrderId', orderContent.preOrderId).set('lineItemStatus', orderContent.lineItemStatus);
            }
        }
        return this.post(constants.cancelPreorderUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getProfileBillingAddress() {
        return this.get(constants.profileBillingAddressUrl).pipe(operators_1.map((data) => data));
    }
    getProfileCreditCards(cachedResponse) {
        if (this.profileCrediCardsResponse && cachedResponse) {
            return rxjs_1.of(this.profileCrediCardsResponse);
        }
        else if (this.profileCrediCardsObservable && cachedResponse) {
            return this.profileCrediCardsObservable;
        }
        else {
            this.profileCrediCardsObservable = this.get(constants.profileCreditCardsUrl).pipe(operators_1.map((data) => {
                this.profileCrediCardsObservable = null;
                this.profileCrediCardsResponse = data;
                return data;
            }), operators_1.share());
            return this.profileCrediCardsObservable;
        }
    }
    validateBillToAccount(cachedResponse, content) {
        if (this.billToAccountEligibilityResponse && cachedResponse) {
            return rxjs_1.of(this.billToAccountEligibilityResponse);
        }
        else if (this.billToAccountEligibilityObservable && cachedResponse) {
            return this.billToAccountEligibilityObservable;
        }
        else {
            let inputArgs;
            if (content) {
                const data = JSON.stringify(content);
                inputArgs = new http_1.HttpParams().set('preOrderDetails', data);
            }
            this.billToAccountEligibilityObservable = this.post(constants.billToAccountUrl, inputArgs.toString()).pipe(operators_1.map((data) => {
                this.billToAccountEligibilityObservable = null;
                this.billToAccountEligibilityResponse = data;
                return data;
            }), operators_1.share());
            return this.billToAccountEligibilityObservable;
        }
    }
    getBillToAccountDetails(cachedResponse) {
        if (this.billToAccountDetailsResponse && cachedResponse) {
            return rxjs_1.of(this.billToAccountDetailsResponse);
        }
        else if (this.billToAccountDetailsObservable && cachedResponse) {
            return this.billToAccountDetailsObservable;
        }
        else {
            this.billToAccountDetailsObservable = this.get(constants.getBillToAccountDetailsUrl).pipe(operators_1.map((data) => {
                this.billToAccountDetailsObservable = null;
                this.billToAccountDetailsResponse = data;
                return data;
            }), operators_1.share());
            return this.billToAccountDetailsObservable;
        }
    }
    getAllStatesList() {
        return this.get(constants.allStateListUrl).pipe(operators_1.map((data) => data));
    }
    updatePreorderTender(content) {
        let inputArgs;
        if (content) {
            const data = JSON.stringify(content);
            inputArgs = new http_1.HttpParams().set('tenderInfo', data);
            ;
        }
        return this.post(constants.updatePreorderTenderUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    // Oauth token service
    getOauthAccessToken() {
        return this.get(constants.oauthTokenUrl).pipe(operators_1.map((data) => data));
    }
    // Payment Token Service
    getPaymentToken(content, header, paymentUrl) {
        return this.post(paymentUrl, content, true, header).pipe(operators_1.map((data) => data));
    }
    getCreditCardRequest(payment, address, amountToPay) {
        const expMon = parseInt(payment.expirationMonth, 10);
        const expirationYear = parseInt(payment.expirationYear, 10);
        const creditCardTokenReq = {
            clientName: 'MMA',
            card: {
                firstName: address.firstName,
                lastName: address.lastName,
                cardNumber: payment.creditCardNumber,
                expMonth: expMon,
                expYear: expirationYear,
                address: address.address1,
                zipCode: address.postalCode,
                cvv: payment.cvv,
                amount: amountToPay,
                cardDataCaptureMethod: 'Manual',
                isGiftCard: false
            }
        };
        return creditCardTokenReq;
    }
    getDisplayCardType(creditType) {
        let creditTypeDisplay = null;
        if (creditType != null) {
            if (creditType === 'AMEX' || creditType === 'AMERICANEXPRESS' || creditType === 'AMERICAN_EXPRESS') {
                creditTypeDisplay = 'American Express';
            }
            else if (creditType === 'MASTER' || creditType === 'MASTERCARD' || creditType === 'MASTER_CARD') {
                creditTypeDisplay = 'MasterCard';
            }
            else if (creditType === 'VISA') {
                creditTypeDisplay = 'Visa';
            }
            else if (creditType === 'DISCOVER') {
                creditTypeDisplay = 'Discover';
            }
            else {
                creditTypeDisplay = null;
            }
            creditTypeDisplay = creditTypeDisplay !== null ? creditTypeDisplay : creditType;
        }
        return creditTypeDisplay;
    }
    getCSErrorMessage() {
        return this.get(constants.tokenServiceErrorMsgUrl).pipe(operators_1.map((data) => data));
    }
    getEligiblePreorderDevices(subId) {
        return this.getWithIncreasedTomeout(constants.getPreOrderEligibleDevicesUrl + subId, constants.preorderTimeout).pipe(operators_1.map((data) => data));
    }
    getPOCSubElibigibility(subId) {
        return this.get(constants.getPOCSubEligibilityUrl + subId).pipe(operators_1.map((data) => data));
    }
    getAccountType() {
        return this.get(constants.getAccountTypeUrl).pipe(operators_1.map((data) => data));
    }
    getProductDetails(prodId) {
        return this.get(constants.getProductUrl + prodId).pipe(operators_1.map((data) => data));
    }
    checkDPPTermEligibility(productIds) {
        let inputArgs;
        if (productIds) {
            inputArgs = new http_1.HttpParams().set('productId', productIds);
        }
        return this.post(constants.dppTermEligibilityCheckUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    replaceDevice(content) {
        let inputArgs;
        if (content) {
            inputArgs = new http_1.HttpParams().set('preorderId', content.preorderId).set('deviceId', content.deviceId).set('subId', content.subId).set('isDPP', content.isDPP)
                .set('isPOC', content.isPOC).set('curDeviceId', content.curDeviceId).set('hasTradeIn', content.hasTradeIn).set('isPreOrder', content.isPreOrder)
                .set('deviceTermId', content.deviceTermId).set('deviceTermLength', content.deviceTermLength).set('monthlyInstallment', content.monthlyInstallment);
        }
        return this.post(constants.replaceDeviceUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getVerificationStatus(preorderId) {
        return this.get(constants.verificationStatusUrl + preorderId).pipe(operators_1.map((data) => data));
    }
    getAppleCareDetails(prodId) {
        return this.get(constants.appleCareDetailsUrl + prodId).pipe(operators_1.map((data) => data));
    }
    /**
     * @param csn a string that contains the csn of the product
     *  @returns Observable of type [Insurance] - returns a list of recommended accessories
     */
    getInsuranceDetails(csn) {
        return this.get(constants.getInsuranceUrl + csn).pipe(operators_1.map((res) => res));
    }
}
exports.OrderStatusService = OrderStatusService;
//# sourceMappingURL=orderStatus.service.js.map